// extracted by mini-css-extract-plugin
export default {"menu":"Program_menu__5Ce5T","nav":"Program_nav__o8YPJ"};